import {
  useFormField,
  useFormFieldsContext,
} from '@spotify/confidence-core-react';
import { MetricsV1MetricAverageMetricSpec } from '@spotify/confidence-graphql';

import { MetricFormValues } from '../../createMetricDialog/types';
import { AggregationForm } from './AggregationForm';
import { replaceEntityNullWithZeroAggs } from './aggregationUtils';

export const AverageMeasurementFormFields = () => {
  const { setValues } = useFormFieldsContext<MetricFormValues>();

  const { value: entity } = useFormField<MetricFormValues, 'entity'>('entity');

  const { value: factTable } = useFormField<MetricFormValues, 'factTable'>(
    'factTable',
  );

  const { value: typeSpec } = useFormField<MetricFormValues, 'typeSpec'>(
    'typeSpec',
  );

  const handleChange = (
    averageMetricSpec: MetricsV1MetricAverageMetricSpec,
  ) => {
    setValues({
      typeSpec: {
        averageMetricSpec,
      },
      nullHandling: {
        replaceEntityNullWithZero: replaceEntityNullWithZeroAggs.includes(
          averageMetricSpec.aggregation.type,
        ),
      },
    });
  };

  if (!typeSpec?.averageMetricSpec) {
    return null;
  }

  return (
    <AggregationForm
      value={typeSpec.averageMetricSpec}
      onChange={handleChange}
      entity={entity || ''}
      factTable={factTable || ''}
    />
  );
};
